import React from 'react';
import {
  CssBaseline,
  Container,
  Paper,
} from '@mui/material';
import Grid from "@mui/material/Grid2"
import {useTheme} from "@mui/material/styles";

import {whiteBackgroundColor} from '../../constants';
import imgSrcLogo from "../../image/MM_logo.png";
import {Registration, EmailVerification} from "./Registration";
import {Login} from "./Login";
import {ResetPassword, ChangePassword} from "./ResetPassword";
import {Step} from "../Steps";

import {Route, Redirect, Switch} from "react-router-dom";

export function Auth() {
  const theme = useTheme();

  return (
    <Container
      component="main"
      maxWidth="sm"
      style={{
        marginTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
        minWidth: '600px'
      }}
    >
      <CssBaseline/>
      <Grid container>
        <img src={imgSrcLogo} alt="Manhart" style={{width: '15%', margin: 'auto'}}/>
        <Paper square={true} sx={{
          width: '100%',
          marginTop: theme.spacing(4),
          padding: theme.spacing(4),
          display: 'flex',
          flexDirection: 'column',
          backgroundColor: whiteBackgroundColor
        }}>
          <Switch>
            <Route exact path="/auth" component={Login}/>
            <Route exact path="/registration" component={Registration}/>
            <Route exact path="/emailverification" component={EmailVerification}/>
            <Route exact path="/login" component={Login}/>
            <Route exact path="/resetpassword" component={ResetPassword}/>
            <Route exact path="/changepassword" component={ChangePassword}/>
            <Route path={"/step"} component={Step}/>
            <Route path="/" render={() => {
              return <Redirect to={"/step/1"}/>;
            }}/>
          </Switch>
        </Paper>
      </Grid>
    </Container>
  );
}


